import React from "react";

export default function HoaPdfViewer(props: any) {
    const { fileUrl  } = props;

    if(!fileUrl) {
        return (<></>);
    }

    return (
		<>
            <object data={fileUrl} type="application/pdf" style={{ width: "100%", height: "723px", border: "1px solid #e8e8e8" }}>
                <div className='m-3'>
                    <p>
                        Your browser does not support viewing this file.
                        You can <a href={fileUrl} target="_blank">click here to download the file</a >.
                    </p> 
                </div>
            </object>
        </>
	);
}